import { render, staticRenderFns } from "./homeSetting.vue?vue&type=template&id=6190b797&scoped=true"
import script from "./homeSetting.vue?vue&type=script&lang=ts"
export * from "./homeSetting.vue?vue&type=script&lang=ts"
import style0 from "./homeSetting.vue?vue&type=style&index=0&id=6190b797&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6190b797",
  null
  
)

export default component.exports